/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import { environment } from "./environments/environment"

const awsmobile = environment.AWS_EXPORT_CONFIG;


export default awsmobile;
